import { useState, useContext } from "react";
// Import Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useEntitlementPostpone } from "../../hooks/useEntitlementPostpone";
import { useCheckAPI } from "../../hooks/useCheckAPI";
// MUI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutlined";

export const PostponeEntitlementDialog = ({ disabled, staffId, staffName }) => {
  const [open, setOpen] = useState(false);

  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Add Staff Mutation
  const {
    mutate: entitlementPostpone,
    isSuccess,
    data,
  } = useEntitlementPostpone();

  const handlePostpone = () => {
    entitlementPostpone({
      list: { staff: { staffid: staffId, postponeDaysCnt: 30 } },
    });
  };

  // Success Function
  const successFunc = () => {
    setOpen(false);
    setAlertNotification({
      message: `Entitlement checks for ${staffName} postponed`,
      severity: "info",
    });
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box>
      <IconButton
        aria-label="postpone-entitlement"
        color="primary"
        disabled={disabled}
        onClick={handleClickOpen}
      >
        <PauseCircleOutlineIcon />
      </IconButton>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={handleClose}
        aria-labelledby="postpone-entitlement-dialog"
      >
        <DialogTitle id="postpone-entitlement-dialog-title">
          Postpone Entitlement - {staffName}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Postpone entitlement check for 30 days.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handlePostpone} autoFocus>
            Postpone
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
